import React from 'react'


export interface ConditionalDisplayProps {
    ifTrue: boolean,
    children?: (() => JSX.Element) | JSX.Element,
}

const ConditionalDisplay = ({ ifTrue, children }: ConditionalDisplayProps) => {
    let fetcher =  children instanceof Function ? (children as Function) : (() => children);
    if (ifTrue)
        return <>{fetcher()}</>;
    else
        return null;
};


export default ConditionalDisplay;